import { Component, Input } from '@angular/core';
import { AvatarData } from "../../ui-dto/avatar/avatar-data";
import { AvatarShape } from "../../ui-dto/avatar/avatar-shape";
var HTML_TEMPLATE = "\n<div  *ngIf=\"data !=null\" class=\"od-avatar\" [ngClass]=\"{'od-avatar-disabled':disabled, 'od-avatar-fit':fit}\">\n\t<!--Avatar data image-->\n\t<div *ngIf=\"data.url != null\"\n\t    [class]=\"_shape + ' avatar_img'\" \n\t\t[ngStyle]=\"{'width':_size+'px','height':_size+'px','border-color':_borderColor,\n\t\t'background-image': 'url('+data.url+')'}\"></div>\n\t<!--Avatar data icon -->\n\t<div *ngIf=\"data.icon != null && data.url == null\"\n\t\t[class]=\"_shape + ' ' + data.icon +' od-avatar-icon'\" \n\t\t[ngStyle]=\"{'width':_size + 'px','height':_size + 'px','border-color':_borderColor,'background-color':_borderColor,'color':data.iconColor,\n\t\t'font-size': _size/1.4 + 'px'}\">\n\t</div>\n\t<!--Avatar data initials-->\n\t<label *ngIf=\"data.initials != null && data.url == null && data.icon == null\" \n\t    [class]=\"_shape\" \n\t\t[ngStyle]=\"{'width':_size+'px','height':_size+'px','border-color':_borderColor,'background-color':data.color,\n\t\t'color': data.fontColor,'font-size': _size/2.2 + 'px'}\">\n\t\t{{data.initials}}\n\t</label>\n</div>";
var CSS_STYLE = "\n.od-avatar {\n  display: flex;\n  justify-content: center;\n}\n\n.od-avatar-fit {\n  width: fit-content;\n}\n\n.od-avatar.od-avatar-disabled{\n\tfilter: grayscale(100%) brightness(120%) opacity(90%);\n}\n\n.od-avatar-icon{\n    font-weight: 400 !important;\n}\n\n.od-avatar > .avatar_img{\n\tbackground-size: cover;\n\tbackground-position: center;\n}\n\n.od-avatar > .circle{\n  border-radius: 100px;\n}\n\n.od-avatar > div,\n.od-avatar > label{\n\tborder: 1px solid transparent;\n\tborder-radius: unset;\n\toverflow: hidden;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground-size: cover;\n\tbackground-position: center;\n\tfont-weight: bold;\n\tcolor: white;\n\tflex: none;\n\ttext-transform: uppercase;\n}";
var Avatar = /** @class */ (function () {
    function Avatar() {
        this._shape = AvatarShape.CIRCLE;
        this._borderColor = "transparent";
        this._size = 37;
        this.fit = true;
    }
    Object.defineProperty(Avatar.prototype, "shape", {
        set: function (value) {
            if (value != null)
                this._shape = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Avatar.prototype, "borderColor", {
        set: function (value) {
            if (value != null)
                this._borderColor = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Avatar.prototype, "size", {
        set: function (value) {
            if (value != null)
                this._size = value;
        },
        enumerable: true,
        configurable: true
    });
    Avatar.decorators = [
        { type: Component, args: [{
                    selector: 'od-avatar',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Avatar.ctorParameters = function () { return []; };
    Avatar.propDecorators = {
        "data": [{ type: Input },],
        "disabled": [{ type: Input },],
        "fit": [{ type: Input },],
        "shape": [{ type: Input },],
        "borderColor": [{ type: Input },],
        "size": [{ type: Input },],
    };
    return Avatar;
}());
export { Avatar };
//# sourceMappingURL=avatar.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/avatar/avatar.js
// module id = 406
// module chunks = 14